import { store } from '@/common/root';

const fetchLoadBalancerName = async (loadBalancerId): Promise<string> => {
  const loadBalancer = await store.$takeFirst('lbaas/loadBalancers/GET_OR_LOAD', { id: loadBalancerId });
  return loadBalancer.name;
};

export default fetchLoadBalancerName;
